<template>
  <div justify="center">
    <v-dialog v-model="dialog" scrollable  fullscreen  persistent>
      <template v-slot:activator="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" small icon v-on="on" @click="dialog = !dialog">
              <v-icon>mdi-arrow-up-thin-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Cargar Cartera</span>
        </v-tooltip>
      </template>

      <v-card class="mx-auto">
        <v-toolbar color="black" dark>Cargar Cartera</v-toolbar>

        <v-card-text>
          <loadCartera />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="black">
          <v-spacer></v-spacer>
          <v-btn color="amber" text @click="dialog = false">
            Cerrar
          </v-btn>
          <!--
          <v-btn color="blue darken-1" text @click="dialog = false">
            Save
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loadCartera from "../../../components/loadFile/carteras/procesaCVS.vue";

export default {
  name: "cargarCartera",
  props: [],
  components: {
    loadCartera,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {},
  computed: {
    retornaEstadoMensaje() {
      //return (this.sheet = this.estadoMensaje);
    },
  },
};
</script>